import React from 'react';

export default function Keypad({ team, onDigit, onClear, onSubmit, disabled }) {
  const teamClass = team === 'team1' ? 'keypad-team1' : 'keypad-team2';

  const handleClick = (value) => {
    if (disabled) return;
    if (value === 'C') {
      onClear();
    } else if (value === '✓') {
      onSubmit();
    } else {
      onDigit(value.toString());
    }
  };

  const buttons = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    ['C', 0, '✓']
  ];

  return (
    <div className={`keypad ${teamClass}`} data-testid={`${team}-keypad`}>
      {buttons.map((row, rowIndex) => (
        <div className="keypad-row" key={rowIndex}>
          {row.map((btn) => {
            let btnClass = 'keypad-btn';
            if (btn === 'C') btnClass += ' keypad-btn-clear';
            else if (btn === '✓') btnClass += ' keypad-btn-submit';
            else btnClass += ' keypad-btn-digit';

            return (
              <button
                key={btn}
                className={btnClass}
                onClick={() => handleClick(btn)}
                disabled={disabled}
                data-testid={`${team}-keypad-${btn === '✓' ? 'submit' : btn === 'C' ? 'clear' : `digit-${btn}`}-button`}
                aria-label={btn === '✓' ? 'submit' : btn === 'C' ? 'clear' : `digit ${btn}`}
              >
                {btn}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
